<template>
    <div>
         <!-- =============================================================================== -->

        <!-- =============================================================================== -->

       <v-row justify="center">
          <v-dialog v-model="$store.state.showDialogGuia.declaracao_aproveitamento" max-width="600px">
            <v-overlay :value="$store.state.isloading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
            <v-card>
              <v-card-title>
                <span class="headline">Informações Pessoais</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <span>Nome completo: <v-chip color="primary">{{($store.state.objAluno === undefined)?'':$store.state.objAluno.nome}}</v-chip> </span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span>Número de matricula:    <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.idMAtricula}}</strong>  </span>
                    </v-col>
                     <v-col cols="12" sm="6" md="6">
                      <span>Nº Bilhete: <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.bi}}</strong> </span>
                    </v-col>
                     <v-col cols="12" sm="6" md="6">
                      <span>Curso :  <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.curso}}</strong> </span>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <span>Classe : <strong>{{($store.state.objAluno === undefined)?'':$store.state.objAluno.classe}}</strong> </span>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                         <v-card-title>
                            <span class="headline">Efeito da Declaração</span>
                        </v-card-title>
                    </v-col>

                    <v-col cols="12" sm="4">
                       <v-select
                        v-model="efeitoSelected"
                        item-value="idEfeito"
                        item-text="descricao"
                        :items="efeitos"
                        label="Selecione o efeito"
                        return-object
                      ></v-select>
                    </v-col>

                    <v-col cols="12" sm="4">
                       <v-select
                        v-model="frequencia"
                        item-value="descricao"
                        item-text="full"
                        :items="frequencialAll"
                        label="Estado do estudante"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                       <v-select
                        v-model="modelo"
                        item-value="id"
                        item-text="descricao"
                        :items="modelosImpressao"
                        label="Modelo de Impressão"
                        return-object
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="sair()">Cancelar</v-btn>
                 <v-btn :disabled="isHabilitado" color="blue darken-1" text @click="Declaracao()">Vizualizar</v-btn>
               </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

  <!--================================================================================== -->

    </div>
    </template>
<script>
import axios from '../../../plugins/axios'
import impressao from '../../../utilitarios/impressao.utilitario'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  data: () => ({
    modelosImpressao: [{ id: 1, descricao: 'IMS' }, { id: 2, descricao: 'Local' }],
    modelo: { id: 2, descricao: 'Local' },
    notas: [],
    dialog_dec: true,
    efeitos: [],
    efeitoSelected: null,
    relatorio: ls.get('relatorio-estudante'),
    html: ``,
    titulo: 'A Declaração de Aproveitamento',
    frequencia: null,
    frequencialAll: [
      { id: 1, descricao: 'Frenquenta', full: 'Atual estudante da instituição' },
      { id: 2, descricao: 'Frenquentou', full: 'Antigo estudante da instituição' }
    ],
    configuracoesReport: ls.get('configuracoesReport')
  }),
  computed: {
    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },

    instituicaoId () {
      return ls.get('i_id')
    },
    isModeloIMS () {
      return this.modelo.id == 2 ? ls.get('i_id') : 1
    },
    isHabilitado () {
      return !(this.modelo && this.frequencia && this.efeitoSelected)
    }
  },
  created  () {
    this.efeitosDeclaracao()
  },
  methods: {
    async efeitosDeclaracao () {
      this.$store.state.isloading = true

      try {
        this.efeitos = await axios
          .get('/efeitos-declaracao')
          .then(res => res.data)
        this.$store.state.isloading = false
      } catch (error) {
        this.sair()
        Swal.fire({
          icon: 'error',
          title: '',
          text: 'Ocorreu um erro'
        })
      }
    },
    formatarDataParaDescricao (data) {
      const d = new Date(data)
      const meses = [
        'Janeiro', 'Fevereiro', 'Março', 'Abril',
        'Maio', 'Junho', 'Julho', 'Agosto',
        'Setembro', 'Outubro', 'Novembro', 'Dezembro'
      ]

      const dia = d.getDate()
      const mes = meses[d.getMonth()]
      const ano = d.getFullYear()

      return `${dia} de ${mes} de ${ano}`
    },

    descricaoEscola () {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (this.$store.state.objAluno.idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
    getlogotipo () {
      let logotipoInstituto = ls.get('configuracoesReport').filter(c => c.chave === 'logotipo2')
      return (ls.get('isintegrado') === 0) ? ls.get('insignia') : (this.$store.state.objAluno.idCurso <= 24 ? ls.get('logotipo') : (logotipoInstituto[0].valor))
    },
    async Declaracao () {
      const dataAtual = new Date()
      const data = this.formatarDataParaDescricao(dataAtual)
      let declaracaoConfiguracoes = this.configuracoesReport.filter(c => c.obs === 'Declaração')

      let template = ''
      let dados = {
        '{{nome}}': this.$store.state.objAluno.nome,
        '{{efeito}}': this.efeitoSelected.descricao,
        '{{pai}}': this.$store.state.objAluno.nomedopai,
        '{{mae}}': this.$store.state.objAluno.nomedamae,
        '{{municipio}}': this.$store.state.objAluno.municipio,
        '{{provincia}}': this.$store.state.objAluno.provincia,
        '{{numeroBi}}': this.$store.state.objAluno.bi,
        '{{emissaoBi}}': this.formatarDataParaDescricao((this.$store.state.objAluno.dataemissaobi).substring(0, 10)),
        '{{classe}}': this.$store.state.objAluno.classe,
        '{{turma}}': this.$store.state.objAluno.turma,
        '{{periodo}}': this.$store.state.objAluno.periodo,
        '{{curso}}': this.$store.state.objAluno.curso,
        '{{anoLectivo}}': this.$store.state.objAluno.novadescricao,
        '{{dataActual}}': data.toUpperCase(),
        '{{frequencia}}': this.frequencia,
        '{{logotipo}}': this.getlogotipo(),
        '{{institutoDescricao}}': this.descricaoEscola(),
        '{{instituicao}}': this.descricaoEscola(),
        '{{dataNascimento}}': this.formatarDataParaDescricao(this.$store.state.objAluno.datanascimento),
        '{{siglaEFTSL}}': (this.$store.state.objAluno.idCurso <= 24 ? declaracaoConfiguracoes[1].valor : ''),
        '{{assinante01}}': (declaracaoConfiguracoes[2].valor),
        '{{assinante02}}': (declaracaoConfiguracoes[3].valor),
        '{{matricula}}': this.$store.state.objAluno.idMAtricula,
        '{{resultado}}': (this.$store.state.objAluno.resultado ? this.$store.state.objAluno.resultado : 'Não Transita')
      }

      try {
        template = await axios.get('/obterRelatorioByDescricao/dap').then((res) => res.data)
        template = template.filter(r => r.idinstituicao == this.isModeloIMS)
        if (!template.length) {
          this.$store.state.isloading = false
          Swal.fire({ icon: 'info', title: '', text: 'Declaração de Aproveitamento, não configurada!' })
        } else {
          let header = template[0].documentoiteracao2
          const expressaoRegular = new RegExp(Object.keys(dados).join('|'), 'g')
          template = template[0].documento.replace(expressaoRegular, (match) => dados[match])

          this.html = template
          try {
            this.$store.state.isloading = true
            let option = {
              'format': 'A4',
              'border': { 'top': '20cm', 'bottom': '20cm', 'left': '25cm', 'right': '25cm' },
              'header': { 'height': '5mm', 'contents': { first: header } },
              'footer': { 'height': '5mm' }
            }

            this.$store.state.showDialogGuia.declaracao_aproveitamento = false
            impressao.htmlToPDF(this.html, option, ls.get('urlReport'), ls.get('idPessoa'))
          } catch (error) {
            this.sair()
          }
        }
      } catch (error) {
        this.$store.state.isloading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro durante a impressão da Declaração de Aproveitamento!' })
      }
    },
    sair () {
      this.$store.state.isloading = false
      this.$store.state.showDialogGuia.declaracao_aproveitamento = false
    }
  }
}

</script>
